import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Hoc from "../../../components/HOC";
import FormButton from "../../../components/FormButton";
import FormContainer from "../../../components/FormContainer";
import {
  FaPlus,
  FaEdit,
  FaTrash,
  FaEye,
  FaFileDownload,
  FaClock,
} from "react-icons/fa";
import TimeSheet from "../TimeSheet";
import EditTimesheet from "../TimeSheet/EditTimesheet";
import { toast } from "react-toastify";
import moment from "moment";
import Swal from "sweetalert2";
import { parseLocalStorageJSON } from "../../../helpers/Localstorage";
import Loader from "../../../components/Loader";
import { MdCancel, MdEdit, MdPending } from "react-icons/md";
import CustomToolTip from "../../../components/ToolTip";
import { FcApproval, FcCancel } from "react-icons/fc";
import CustomDataTable from "../../../components/CustomDataTable";
import { 
  requestAddTimesheet,
  requestEditTimesheets, 
  requestGetTimesheetById,
  requestTimesheetById,
  requestTimesheetsByIdForUserPage,
  responseGetTimesheetById,
  setResetAddTimesheet,
  setResetEditTimesheets,
  setResetGetTimesheetById,
  setResetStateTimesheetById,
  setResetStateTimesheetsByIdForUserPage,
  openTimesheetModal,
  closeTimesheetModal,
} from "../../../Redux/TimeSheetState/TimeSheetActionCreator";
import {
  requestProjectsById,
  setResetStateProjectsById,
} from "../../../Redux/ProjectState/ProjectActionCreator";
import CustomDropdown from "../../../components/CustomDropdown";
import AlertsCard from "../../../components/AlertsCard";
import { CalendarIcon } from "lucide-react";
import { Tooltip } from "recharts";
import ViewTimesheet from "../TimeSheet/ViewTimesheet";
 
const ManageTimesheets = () => {
  const [selectedTimesheet, setSelectedTimesheet] = useState(null);
  const [timesheets, setTimesheets] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [mode, setMode] = useState(null); // 'edit' or 'view'
  const TimeSheets = useSelector(
    (state) => state.TimeSheetByProjectIdReducerForUserPage
  );
  const editTimesheetReducer = useSelector(
    (state) => state.EditTimesheetsReducer
  );
  const AddTimeSheetSate = useSelector((state) => state.AddTimesheetReducer);
  const [loading, setLoading] = useState(true);
  const [showViewModal, setShowViewModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [projectFilter, setProjectFilter] = useState("active");
  const projectsList = useSelector((state) => state.ProjectsByIdReducer);
  const timesheetByIdReducer = useSelector(
    (state) => state.GetTimesheetByIdReducer
  );
  const dispatch = useDispatch();
  const isLoading = useSelector(
    (state) =>
      state.AddTimesheetReducer.loading || state.EditTimesheetsReducer.Loading
  );
 
  const columns = [
    {
      name: "Start Date",
      selector: (row) => moment(row.startDate, "MM-DD-YYYY").format("MM-DD-YYYY"),
      sortable: true,
      cell: (row) => (
        <div className="flex items-center">
          <span className="truncate">{moment(row.startDate, "MM-DD-YYYY").format("MM-DD-YYYY")}</span>
        </div>
      ),
    }, 
    {
      name: "End Date",
      selector: (row) => moment(row.endDate, "MM-DD-YYYY").format("MM-DD-YYYY"),
      sortable: true,
      cell: (row) => (
        <div className="flex items-center">
          <span className="truncate">{moment(row.endDate, "MM-DD-YYYY").format("MM-DD-YYYY")}</span>
        </div>
      ),
    },
    {
      name: "Location",
      selector: (row) => row.work_location,
      sortable: true,
      hide: "sm",
    },
    {
      name: "Total Hours",
      selector: (row) => row.total_hours,
      sortable: true,
      hide: "sm",
    },
    {
      name: "Status",
      selector: (row) => {
        let label = "";
        let styleClass = "";
 
        switch (row.status) {
          case "APP":
            label = "APPROVED";
            styleClass = "bg-green-100 text-green-800";
            break;
          case "SUB":
            label = "PENDING";
            styleClass = "bg-yellow-100 text-yellow-800";
            break;
          case "REJ":
            label = "REJECTED";
            styleClass = "bg-red-100 text-red-800";
            break;
          case "RESUB":
            label = "RESUBMITTED";
            styleClass = "bg-gray-100 text-gray-800";
            break;
          default:
            label = "UNKNOWN";
            styleClass = "bg-gray-100 text-gray-800";
            break;
        }
 
        return (
          <span
            className={`px-3 py-1 text-xs font-medium rounded-full ${styleClass}`}
          >
            {label}
          </span>
        );
      },
      sortable: true,
      hide: "sm",
    },
 
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex space-x-2">
          <div className="lg:hidden">
            {row.status === "APP" && (
              <span className="text-green-500 text-[12px]">Approved</span>
            )}
            {row.status === "REJ" && (
              <span className="text-red-500 text-[12px]">Rejected</span>
            )}
            {row.status === "SUB" && (
              <span className="text-yellow-500 text-[10px]">Submitted</span>
            )}{row.status === "RESUB" && (
              <span className="text-blue-500 truncate text-[10px]">ReSubmitted</span>
            )}
          </div>
          <button
            disabled={row.status === "APP"}
            onClick={(e) => handleEdit(e, row)}
            className={`text-indigo-600 hover:text-indigo-900 p-1 rounded hover:bg-indigo-50 disabled:cursor-not-allowed
            ${row.status === "APP" ? "hidden sm:block" : "block sm:hidden"}
            ${
              row.status === "REJ" ||
              row.status === "SUB" ||
              row.status === "RESUB"
                ? "block lg:block"
                : ""
            }
            `}
          >
            <FaEdit
              className={
                row.status === "APP" ? "text-gray-300" : "text-primary"
              }
            />
          </button>
          <button
            onClick={(e) => handleView(e, row)}
            className="text-indigo-600 hover:text-indigo-900 p-1 rounded hover:bg-indigo-50"
            title="View Details"
          >
            <FaEye className="text-primary" />
          </button>
        </div>
      ),
    },
  ];
 
  // Reset all modal states
  const resetModalStates = () => {
    setShowViewModal(false);
    setIsEditMode(false);
    setMode(null);
    setModalTitle("");
    dispatch(setResetGetTimesheetById());
    dispatch(setResetEditTimesheets());
    dispatch(setResetStateTimesheetById());
    dispatch(closeTimesheetModal());
  };
 
  const handleEdit = (e, row) => {
    e.preventDefault();
    e.stopPropagation();
    resetModalStates(); // Reset states before setting new ones
    setModalTitle("Edit TimeSheet");
    setIsEditMode(true);
    setMode('edit');
    dispatch(requestGetTimesheetById(row.id));
  };
 
  const handleView = (e, row) => {
    e.preventDefault();
    e.stopPropagation();
    resetModalStates(); // Reset states before setting new ones
    setMode('view');
    dispatch(requestGetTimesheetById(row.id));
  };
 
  const handleClose = () => {
    resetModalStates();
  };
 
  const handleAddNewTimesheet = () => {
    resetModalStates(); // Reset states before setting new ones
    setModalTitle("Add TimeSheet");
    setIsEditMode(false);
    dispatch(openTimesheetModal());
  };
 
  // Handle page change
  const handlePageChange = (page) => {
    if (selectedOption) {
      dispatch(
        requestTimesheetsByIdForUserPage({
          project: selectedOption,
          page: page,
          size: TimeSheets?.size ,
        })
      );
    }
  };
 
  // Handle rows per page change
  const handleRowsChange = (size) => {
    if (selectedOption) {
      dispatch(
        requestTimesheetsByIdForUserPage({
          project: selectedOption,
          page: 0,
          size: size,
        })
      );
    }
  };
 
  const handleAddTimeSheet = (values, selectedFiles) => {
    if (modalTitle === "Add TimeSheet") {
      const holidays = (values.holidays || []).map((holiday) => ({
        employee_holiday_date: holiday.employee_holiday_date,
        notes: holiday.notes,
      }));
      const timeSheetPayload = {
        ...values,
        holidays: holidays,
      };

      // Create FormData for multipart/form-data
      const formData = new FormData();
      formData.append("timeSheets", JSON.stringify([timeSheetPayload]));
      if (selectedFiles && selectedFiles.length > 0) {
        selectedFiles.forEach((file) => {
          formData.append("files", file);
        });
      }

      dispatch(requestAddTimesheet(formData));
    } else {
      const editTimeSheetPayload = {
        projectId: values.projectId?.id || values.projectId,
        work_location: values.work_location,
        startDate: values.startDate,
        endDate: values.endDate,
        total_hours: values.total_hours,
        holidays: values.holidays,
        files: values.files || [], // Include existing files as metadata
      };

      // Create FormData for multipart/form-data (same as add functionality)
      const formData = new FormData();
      formData.append("timeSheet", JSON.stringify(editTimeSheetPayload));
      
      // Only append new files as binary data
      if (selectedFiles && selectedFiles.length > 0) {
        selectedFiles.forEach((file) => {
          formData.append("files", file);
        });
      }

      dispatch(
        requestEditTimesheets({
          id: timesheetByIdReducer?.Response?.id,
          formData: formData,
        })
      );
    }
  };
 
  const handleEditTimeSheet = (values, selectedFiles) => {
    
    const editTimeSheetPayload = {
      projectId: values.projectId?.id || values.projectId,
      work_location: values.work_location,
      startDate: values.startDate,
      endDate: values.endDate,
      total_hours: values.total_hours,
      holidays: values.holidays,
      files: values.files || [], // Include existing files as metadata
    };

    // Create FormData for multipart/form-data (same as add functionality)
    const formData = new FormData();
    formData.append("timeSheet", JSON.stringify(editTimeSheetPayload));
    
    // Only append new files as binary data
    if (selectedFiles && selectedFiles.length > 0) {
      selectedFiles.forEach((file) => {
        formData.append("files", file);
      });
    }

    dispatch(
      requestEditTimesheets({
        id: timesheetByIdReducer?.Response?.id,
        formData: formData,
      })
    );
  };
 

 
  // Filter projects for dropdown
  const today = moment().startOf('day');
  const filteredProjects = (projectsList?.response || []).filter(project => {
    if (projectFilter === "all") return true;
    // If no endDate, consider as active
    if (!project.endDate) return true;
    return moment(project.endDate, "MM-DD-YYYY").endOf('day').isSameOrAfter(today);
  });

  // Check if selected project is active
  const isSelectedProjectActive = selectedOption ? 
    (!selectedOption.endDate || moment(selectedOption.endDate, "MM-DD-YYYY").endOf('day').isSameOrAfter(today)) : 
    false;
 
  // Ensure selectedOption is valid when filter or projects change
  useEffect(() => {
    if (filteredProjects.length > 0) {
      if (!filteredProjects.find(p => p.id === selectedOption?.id)) {
        setSelectedOption(filteredProjects[0]);
      }
    } else {
      setSelectedOption(null);
    }
    // eslint-disable-next-line
  }, [projectFilter, projectsList]);
 
  useEffect(() => {
    if (projectsList?.error && !projectsList?.loading) {
      // toast.error("No Projects found");
      dispatch(setResetStateProjectsById());
    }
  }, [projectsList]);
 
  useEffect(() => {
    if (!timesheetByIdReducer?.Loading && timesheetByIdReducer?.Response) {
      dispatch(openTimesheetModal());
    } else if (!timesheetByIdReducer?.Loading && timesheetByIdReducer?.Error) {
      toast.error("Error fetching Timesheet data");
      dispatch(setResetGetTimesheetById());
    }
  }, [timesheetByIdReducer]);
 
  useEffect(() => {
    if (AddTimeSheetSate.response && !AddTimeSheetSate.loading) {
      toast.success(AddTimeSheetSate.response);
      dispatch(closeTimesheetModal());
      if (selectedOption) {
        dispatch(
          requestTimesheetsByIdForUserPage({
            project: selectedOption,
            page: 0,
            size: TimeSheets?.size || 10,
          })
        );
      }
      dispatch(setResetAddTimesheet());
    } else if (AddTimeSheetSate.error && !AddTimeSheetSate.loading) {
      toast.error(AddTimeSheetSate.error.message);
      dispatch(setResetAddTimesheet());
    }
  }, [AddTimeSheetSate, selectedOption, TimeSheets?.size]);
 
  useEffect(() => {
    if (!editTimesheetReducer?.Loading && editTimesheetReducer?.Response) {
      const updatedTimesheet = editTimesheetReducer.Response;
      const updatedData = TimeSheets.response.content.map((item) =>
        item.id === updatedTimesheet.id
          ? { ...updatedTimesheet, status: "SUB" }
          : item
      );
 
      // Refresh the timesheet data for the current project
      dispatch(
        requestTimesheetsByIdForUserPage({
          project: selectedOption,
          page: TimeSheets?.page || 0,
          size: TimeSheets?.size || 10,
        })
      );
 
      toast.success("Timesheet updated successfully");
      handleClose();
      dispatch(setResetEditTimesheets());
    } else if (!editTimesheetReducer?.Loading && editTimesheetReducer?.Error) {
      toast.error(editTimesheetReducer?.Error?.message);
      dispatch(setResetEditTimesheets());
    }
  }, [editTimesheetReducer, TimeSheets, selectedOption]);
 
  useEffect(() => {
    dispatch(requestProjectsById());
    dispatch(
      setResetStateTimesheetsByIdForUserPage({
        page: TimeSheets?.page,
        size: TimeSheets?.size,
      })
    );
    // dispatch(requestTimesheetsByIdForUserPage({ page: TimeSheets?.page, size: TimeSheets?.size }))
    dispatch(setResetAddTimesheet());
    dispatch(setResetEditTimesheets());
    dispatch(setResetGetTimesheetById());
  }, []);
 
  useEffect(() => {
    // if (selectedOption) {
    //   setInitialValues((prevValues) => ({
    //     ...prevValues,
    //     projectId: selectedOption?.id,
    //   }));
 
    dispatch(setResetStateTimesheetsByIdForUserPage());
    dispatch(
      requestTimesheetsByIdForUserPage({
        project: selectedOption,
        page: TimeSheets.page,
        size: TimeSheets.size,
      })
    );
    // }
  }, [selectedOption]);
 
  useEffect(() => {
    if (TimeSheets?.error && !TimeSheets?.loading) {
      // toast.error("No timesheet found / something went wrong");
      dispatch(setResetStateTimesheetsByIdForUserPage());
    }
  }, [TimeSheets]);
 
  // Update the useEffect to handle both modes
  useEffect(() => {
    const timesheetData = timesheetByIdReducer?.Response;
    
    if (timesheetByIdReducer?.Loading === false) {
      if (timesheetData) {
        if (mode === 'edit') {
          setShowViewModal(false); // Ensure view modal is closed
          dispatch(openTimesheetModal());
        } else if (mode === 'view') {
          dispatch(closeTimesheetModal()); // Ensure edit modal is closed
          setShowViewModal(true);
        }
      } else if (timesheetByIdReducer?.Error) {
        toast.error("Error fetching timesheet details");
        resetModalStates();
      }
    }
  }, [timesheetByIdReducer]);
 
  // Cleanup on unmount
  useEffect(() => {
    return () => {
      resetModalStates();
    };
  }, []);
 
  // Reset modals when project changes
  useEffect(() => {
    resetModalStates();
  }, [selectedOption]);
 
  return (
    <div className="w-full h-[96vh] sm:h-[85vh] md:h-[92vh] lg:h-[96vh] overflow-y-auto sm:overflow-hidden px-5 py-3">
      <AlertsCard />
      <Loader
        isLoading={
          TimeSheets?.loading ||
          projectsList?.loading ||
          timesheetByIdReducer?.Loading ||
          AddTimeSheetSate?.loading
        }
      />
      <FormContainer
        maxWidth="max-w-full"
      >
        <div className="flex flex-col sm:flex-row justify-between items-center gap-3 mt-6">
          <div className="w-full sm:w-1/3">
            {/* Project Filter Toggle */}
            <div className="flex gap-2 mb-2">
              <button
                className={`px-3 py-1 rounded ${projectFilter === "active" ? "bg-indigo-500 text-white" : "bg-gray-200"}`}
                onClick={() => setProjectFilter("active")}
                type="button"
              >
                Active
              </button>
              <button
                className={`px-3 py-1 rounded ${projectFilter === "all" ? "bg-indigo-500 text-white" : "bg-gray-200"}`}
                onClick={() => setProjectFilter("all")}
                type="button"
              >
                All
              </button>
            </div>
            <CustomDropdown
              value={selectedOption}
              customClasses="w-full text-left shadow-sm"
              name="project"
              handleChange={(selectedOption) => {
                setSelectedOption(selectedOption);
              }}
              placeholder="Select Project"
              options={filteredProjects}
              handleGetOptionValue={(option) => option.id}
              handleGetOptionName={(option) => option.projectName}
              required
            />
          </div>
          <div className="relative group">
            <FormButton
              onClick={handleAddNewTimesheet}
              icon={<FaPlus className="ml-1 flex items-center" />}
              title="Add New Timesheet"
              size="md"
              variant="primary"
              disabled={!isSelectedProjectActive}
              className={`w-full sm:w-auto text-sm sm:text-base px-4 py-2 shadow-md transition-all duration-200 ${
                !isSelectedProjectActive 
                ? 'opacity-50 cursor-not-allowed hover:shadow-none' 
                : 'hover:shadow-lg'
              }`}
            />
            <div className="absolute hidden group-hover:block bg-gray-800 text-white text-sm rounded py-1 px-2 -top-8 -right-1/2 transform -translate-x-1/4 whitespace-nowrap">
              {!isSelectedProjectActive 
                ? "Cannot add timesheet" 
                : "Add Timesheet"}
            </div>
          </div>
        </div>
        <div className="mt-4 h-[calc(100vh-280px)] sm:h-[calc(100vh-200px)] md:h-[calc(100vh-260px)] lg:h-[calc(100vh-280px)] overflow-y-auto sm:overflow-hidden sm:overflow-hidden lg:overflow-y-auto">
          <CustomDataTable
            columns={columns}
            data={TimeSheets?.response?.content || []}
            enableSearch={false}
            serverPagenation
            fixedHeader
            fixedHeaderScrollHeight="calc(100vh - 400px)"
            paginationTotalRows={TimeSheets?.response?.totalElements}
            handleChangePage={handlePageChange}
            handleRowsChange={handleRowsChange}
            className="min-h-[400px] sm:min-h-0"
          />
        </div>
      </FormContainer>
 
      {modalTitle === "Add TimeSheet" && !isEditMode && (
        <TimeSheet
          timesheetValues={TimeSheets?.initialValues}
          title={modalTitle}
          onAddTimeSheet={handleAddTimeSheet}
          projectsList={projectsList?.response || []}
          minDate={TimeSheets?.initialValues.startDate}
          maxDate={TimeSheets?.initialValues.endDate}
          isLoading={isLoading}
        />
      )}
 
      {modalTitle === "Edit TimeSheet" && isEditMode && timesheetByIdReducer?.Response && (
        <EditTimesheet
          timesheetValues={timesheetByIdReducer.Response}
          onEditTimeSheet={handleEditTimeSheet}
          projectsList={projectsList?.response || []}
          isLoading={isLoading}
        />
      )}
      <ViewTimesheet
        show={showViewModal}
        onClose={() => {
          setShowViewModal(false);
          dispatch(setResetGetTimesheetById());
        }}
        projectsList={projectsList?.response || []}
      />
    </div>
  );
};
 
export default Hoc(ManageTimesheets);